import { Switch, Redirect } from 'react-router-dom';

import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';
import ErrorRoute from './ErrorRoute';

import {
    Homepage,
    Dealers,
    Dealer,
    ExcelImport,
    Error404,
    Error403,
    CookiesPolicy
} from 'views';

import {
    VitecUsers,
    VitecUser,
    Distributors,
    Distributor,
    ImportRequests
} from 'views/Admin';

import {
    Login,
    ForgotPassword,
    ResetPassword,
    ChangePassword
} from 'views/Account';


let Routes = () => {
    return (
        <Switch>
            <PrivateRoute exact path={'/'} component={Homepage} />

            <PrivateRoute exact path={'/dealers'} component={Dealers} />
            <PrivateRoute exact path={'/dealer/addnew'} component={Dealer} />
            <PrivateRoute exact path={'/dealer/edit/:id'} component={Dealer} />

            <PrivateRoute exact path={'/excelimport/:id'} component={ExcelImport} />

            <PrivateRoute exact path={'/admin/videndumusers'} component={VitecUsers} />
            <PrivateRoute exact path={'/admin/videndumuser/addnew'} component={VitecUser} />
            <PrivateRoute exact path={'/admin/videndumuser/edit/:id'} component={VitecUser} />

            <PublicRoute exact path={'/site-terms/cookies-policy'} component={CookiesPolicy} />

            <PrivateRoute exact path={'/admin/distributors'} component={Distributors} />
            <PrivateRoute exact path={'/admin/distributor/addnew'} component={Distributor} />
            <PrivateRoute exact path={'/admin/distributor/edit/:id'} component={Distributor} />

            <PrivateRoute exact path={'/admin/importrequests'} component={ImportRequests} />

            <ErrorRoute exact path="/error403" component={Error403} />
            <ErrorRoute exact path="/error404" component={Error404} />

            <PublicRoute exact path="/account/login" component={Login} />
            <PublicRoute exact path="/account/changepassword" component={ChangePassword} />
            <PublicRoute exact path="/account/forgotpassword" component={ForgotPassword} />
            <PublicRoute exact path="/account/resetpassword" component={ResetPassword} />

            {/* <Redirect to="/error404" /> */}
        </Switch>
    );
}

export default Routes;